const uomData = [
  { value: "Volume", description: "Volume" },
  { value: "Price", description: "Price" },
  { value: "Cost", description: "Cost" },
];

export default uomData;
